<script lang="ts" setup>
import SearchField from "@/components/inputs/SearchField.vue";
import { useValidation } from "@/composables/useValidation";
import { zipMask } from "@/constants/mask";

const model = defineModel<string>({ default: "" });

const { zipCodeValidator } = useValidation();

const emits = defineEmits<{
  (e: "search"): void;
}>();

withDefaults(
  defineProps<{
    label?: string;
  }>(),
  {
    label: "Zip code",
  },
);
</script>

<template>
  <search-field
    id="search--zip-field"
    v-model="model"
    :label="label"
    :mask="zipMask"
    :rules="[zipCodeValidator]"
    @search="emits('search')"
  />
</template>
